import { StackClientApp } from "@stackframe/react";

export const stackClientApp = new StackClientApp({
  projectId: process.env.REACT_APP_STACK_PROJECT_ID || "3a872e07-920f-4f9c-8671-e7fb80c5cf46",
  tokenStore: "cookie",
});
